// src/utility/safeStorage.js
const safeStorage = {

  getItem: (key) => {
    try {
      //console.log("READ", key);
      return localStorage.getItem(key);
    } catch (e) {
      console.warn('localStorage blocked:', e);
      return null;
    }
  },

  setItem: (key, value) => {
    try {
      //console.log("SAVE", key, value);
      localStorage.setItem(key, value);
    } catch (e) {
      console.warn('localStorage blocked:', e);
    }
  },

  removeItem: (key) => {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      console.warn('localStorage blocked:', e);
    }
  },

  clear: () => {
    try {
      localStorage.clear();
    } catch (e) {
      console.warn('localStorage blocked:', e);
    }
  }
};

export default safeStorage;